import React from 'react';
import _ from 'underscore';
import { translate } from 'react-i18next';
import { Segment, Card, Label, Icon, Button, Message } from 'semantic-ui-react';

import ProgressBar from 'modules/misc/ProgressBar.js';
import Utils from 'utils/Utils.js';
import LoadInline from 'modules/loading/LoadInline.js';
import {colors} from 'style';
import './challenges.css';

var style = {
    content: {
        padding: '1px',
        position:'relative'
    },
    segment: {
        border: 'none',
        boxShadow: 'none',
    },
    cards: {
        justifyContent: 'center'
    },
    card: {
        overflow:'hidden',
        color: '#fff',
        backgroundColor: colors.themeBlue,
    },
    pseudoCard: {
        height: '0px',
        minHeight: '0px',
        border: 'none',
        boxShadow: 'none',
        visibility: 'hidden',
        marginTop: '0',
        marginBottom: '0',
    },
    message: {
        padding: '.78571429em 1.5em .78571429em',
        fontSize: '1rem',
        lineHeight: '1em'
    },
    loaderContainer: {
        marginLeft:'50%'
    },
    categoryBadge: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        width: '40px',
        height: '40px',
        border: '2px solid #fff',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderRadius: '4px',
        backgroundColor: '#fff',
        color: colors.themeDarkGrey,
        fontSize: '30px',
        textAlign: 'center',
        lineHeight: '38px',
    },
    iconHeader: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        height:'62px', 
        padding:'5px 60px 0px 60px', 
        width:'100%',
        color: '#fff',
        backgroundColor: colors.themeTeal,
    },
    challengeMenu: {
        position: 'absolute',
        top: '20px',
        right: '10px',
        fontSize: '16px',
        backgroundColor: 'transparent',
        color: '#fff',
        border: '0px solid #fff',
        boxShadow:'none',
    },
    imageBanner: {
        height:'160px', 
        width:'100%',
        backgroundSize:'cover',
        backgroundPositionY: 'center',
    },
    points: {
        fontSize: '0.9em',
        fontWeight: 'normal',
    },
    starIcon: {
        color: colors.pointsYellow,
    },
    header: {
        fontSize: '1em',
        color:'#fff', 
    },
    duration: {
        color:'#fff', 
    },
    type: {
        color:'#fff', 
    },
    cardContent: {
        position: 'relative'
    },
    skipLeftIcon: {
        backgroundColor: 'rgba(0,0,0,0)',
        color: '#fff',
        position: 'absolute',
        left: '10px',
        top: '50%',
        marginTop: '-20px',
    },
    skipRightIcon: {
        backgroundColor: 'rgba(0,0,0,0)',
        color: '#fff',
        position: 'absolute',
        right: '10px',
        top: '50%',
        marginTop: '-20px',
    },
    addNewGoalIcon: {
        backgroundColor: '#fff',
        color: colors.themeBlue,
        border: 'none',
        boxShadow: 'none',
    },
    addNewGoalBanner: {
        textAlign:'center', 
        lineHeight: '160px',
    },
    levelText: {
        fontWeight: 'light',
        fontSize: '0.9em',
    },
    progressBar: {
        backgroundColor: '#fff',
    }
};

const Challenges = ({t,
                     challenges, 
                     onLaunchChallenge, 
                     onSkipLeft, 
                     onSkipRight, 
                     onClickHistory,
                     formatDuration, 
                     typeToName, 
                     getChallengeImageUrl, 
                     onAddNewGoal}) => (
    <div style={style.content}>
    {(challenges.length>0) && 
        <Segment style={style.segment}>
            <Card.Group style={style.cards}>
                {challenges.map((item)=>(
                        <Card key={item.id} style={style.card} onClick={()=>onLaunchChallenge(item)}>
                            <div style={style.iconHeader}>
                                {Boolean(item.category.badge) ? (
                                    <div style={{...style.categoryBadge, backgroundImage:Utils.url(item.category.badge.url)}} />
                                    ) : (
                                    <i style={{...style.categoryBadge, ...style.defaultCategoryBadge}} className='icon-myHealthSphere-logo' />
                                    )
                                }
                                {!Boolean(item.category.userCategory && item.category.userCategory.categoryLevel) && 
                                    <div style={{height:'15px'}} />
                                }
                                {item.category.title}
                                {Boolean(item.category.userCategory && item.category.userCategory.categoryLevel) && 
                                    <div>
                                        <ProgressBar style={style.progressBar} value={item.category.userCategory.levelActivitiesCompleted} total={item.category.userCategory.categoryLevel.numRequired} borderWidth={'0'} />
                                        <Card.Description style={style.levelText}>
                                            {t('progress_{{completed}}_{{required}}_{{level}}',
                                                {completed: item.category.userCategory.levelActivitiesCompleted,
                                                 required:  item.category.userCategory.categoryLevel.numRequired,
                                                 level:     item.category.userCategory.level})}
                                        </Card.Description>
                                        <Icon style={style.challengeMenu} className='icon-menu' onClick={(e)=>onClickHistory(e, item.category.id)}></Icon> 
                                    </div>
                                }
                            </div>
                            {(item.type!=3 && item.type!=4) &&
                                <div style={{...style.imageBanner, backgroundImage:Utils.url(getChallengeImageUrl(item))}}/>
                            }
                            <Card.Content style={style.cardContent}>
                                {/*<pre>{JSON.stringify(item.category, null, 2)}</pre>*/}
                                {(item.category.canSkip && item.category.numChallenges > 1) &&
                                    <Button icon style={style.skipLeftIcon} onClick={(e)=>onSkipLeft(e,item)}> <Icon className="icon-arrow-left" size="large"/></Button>
                                }
                                {(item.category.canSkip && item.category.numChallenges > 1) &&
                                    <Button icon style={style.skipRightIcon} onClick={(e)=>onSkipRight(e,item)}><Icon className="icon-arrow-right" size="large"/></Button>
                                }
                                <Card.Header style={style.header} textAlign='center'>
                                    {item.title}
                                    <br/>
                                    {item.points &&
                                        <span style={style.points}>{item.points} <Icon className="icon-star" style={style.starIcon} /></span>
                                    }
                                </Card.Header>
                                <Card.Meta style={style.type} textAlign='center'>{t(typeToName(item.type))}</Card.Meta>
                                {Boolean(item.duration>0) &&//Timed
                                    <Card.Meta style={style.duration} textAlign='center'>{formatDuration(item.duration)}</Card.Meta>
                                }
                                {(window.dev && window.dev.showChallengeType) &&
                                    <div style={{position:'absolute', bottom:'0', left:'0'}}>{item.type}</div>
                                }
                                {(item.userChallenge!=null && item.userChallenge.state==1) &&
                                    <Message positive style={style.message}>Completed</Message>
                                }
                            </Card.Content>
                        </Card>
                    ))
                }
                {onAddNewGoal &&
                    <Card key='addNewGoal' style={style.card} onClick={onAddNewGoal}>
                        <div style={style.iconHeader}>
                        </div>
                        <div style={{...style.imageBanner, ...style.addNewGoalBanner}}>
                            <Icon style={style.addNewGoalIcon} size='huge' circular className='icon-plus'></Icon> 
                        </div>
                        <Card.Content style={style.cardContent}>
                            <Card.Header style={style.header} textAlign='center'>
                                {t('categories:::Add New Goal')}
                            </Card.Header>
                        </Card.Content>
                    </Card>
                }
                {/*hack to force left alignment of last row*/}
                {_.times(10, i=>(<Card key={i} style={{...style.card, ...style.pseudoCard}} />))}
            </Card.Group>
        </Segment>
    }
    </div>
);
export default translate(['challenges', 'categories'])(Challenges);



// WEBPACK FOOTER //
// ./src/modules/challenges/Challenges.js